import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Data} from "@angular/router";
import {ReportStore} from '../../../shared/store/report/report.store';
import {PublicReportData} from '../../../shared/store/publicReports/public-reports';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ReportChannelAffinityStore} from '../../../shared/store/report/report-channel-affinity.store';
import {ReportParamsStore} from '../../../shared/store/report/report-params.store';

@Component({
  selector: 'app-channel-affinity-report',
  templateUrl: './channel-affinity-report.component.html',
  styleUrls: ['./channel-affinity-report.component.scss'],
  providers: [
    ReportStore,
    ReportParamsStore,
    ReportChannelAffinityStore
  ]
})
export class ChannelAffinityReportComponent implements OnInit, OnDestroy {
  @Input('publicReportData') set setReport(publicReportData: PublicReportData | null | undefined) {
    if (publicReportData) {
      this._reportStore.initPublicReport(
        publicReportData.report,
        publicReportData.uuid,
        publicReportData.token
      );
    }
  };

  public iframe$: Observable<boolean> = this._route.data.pipe(map((data: Data): boolean => data.iframe || false));
  public disabled$: Observable<boolean> = this._reportStore.submitted$.pipe(map((submitted: boolean): boolean => !submitted));

  constructor(
    private readonly _route: ActivatedRoute,
    private readonly _reportStore: ReportStore,
    private readonly _reportChannelAffinityStore: ReportChannelAffinityStore
  ) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  public onSettings(): void {
    this._reportChannelAffinityStore.settingsDialog();
  }



}
